import React from "react";

function TopButtons({setQuery}) {
  const cities = [
    {
      id: 1,
      title: "london",
    },
    {
      id: 2,
      title: "paris",
    },
    {
      id: 3,
      title: "new york",
    },
    {
      id: 4,
      title: "tokyo",
    },
    {
      id: 5,
      title: "toronto",
    },
  ];

  return (
    <div className="flex items-center justify-around my-6">
      {cities.map((city, id) => (
        <button
          key={id}
          className="text-white text-lg font-medium capitalize active:text-blue-400 hover:scale-105 duration-200 "
          onClick={() => setQuery({q:city.title})}
        >
          {city.title}
        </button>
      ))}
    </div>
  );
}

export default TopButtons;
